import { render, staticRenderFns } from "./validationhelper.vue?vue&type=template&id=0db58be8&"
import script from "./validationhelper.vue?vue&type=script&lang=js&"
export * from "./validationhelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports